import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import NonCompliancesCounterLoader, {
  useAllNonCompliancesCounter,
  useNonCompliancesCounter
} from './_load/NonCompliancesCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  const value = useNonCompliancesCounter()
  const all = useAllNonCompliancesCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <NonCompliancesCounterLoader widget={widget}>
        <Widget widget={widget} />
      </NonCompliancesCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
